// about
$('body').on('click', '.campaign-ils .about', function () {
    openModal('.about-campaign');
    return false;
});

// share
$('body').on('click', '.campaign-ils .share', function () {
    var $this = $(this);

    if (navigator.share) {
        navigator.share({
            title: $this.attr('data-title'),
            url: $this.attr('data-url')
        }).then(() => {
            console.log('thanks for shareing');
        }).catch(console.error);
        return false;
    }


    openModal('.share-campaign');
    return false;
});


$('body').on('click', '.campaign-ils .select-amount-trigger', function () {
    var $this = $(this);
    $('.campaign-ils .add-donation').removeClass('hidden');

    $('.campaign-ils [name="amount"]').val($this.attr('data-amount'));
    if (!$this.attr('data-amount')) {
        $('.campaign-ils [name="amount"]').focus();
    }

    $('html, body').animate({ scrollTop: $('.add-donation').offset().top }, 300);

    if ($('.recaptcha-wrapper').length) {
        grecaptcha.execute();
    }

    return false;
});

$('body').on('click', '.campaign-ils .to-donate', function () {
    $('.campaign-ils .add-donation').removeClass('hidden');
    $('.campaign-ils [name="amount"]').select();
    $('html, body').animate({ scrollTop: $('.add-donation').offset().top }, 300);

    if ($('.recaptcha-wrapper').length) {
        grecaptcha.execute();
    }
    return false;
});

$('body').on('click', '.campaign-ils .donate-trigger', function () {
    $('html, body').animate({
        scrollTop: $('.add-donation .fields').offset().top - 20
    }, 300);

    return false;
});


$('body').on('change', '.campaign-ils .add-donation [name="method"]', function () {
    var $this = $(this);
    var method = $this.val();

    if (method === 'card') {
        $('.campaign-ils .add-donation .card').parents('li').removeClass('hidden');
        $('.campaign-ils .add-donation .card').addClass('required');
        return false;
    }

    if (method === 'paypal') {
        $('.campaign-ils .add-donation .card').parents('li').addClass('hidden');
        $('.campaign-ils .add-donation .card').removeClass('required');
    }

});

// submit the donation
$('body').on('submit', '.campaign-ils .add-donation form', function () {
    var $this = $(this);

    var amount = parseFloat($('.campaign-ils .add-donation input[name="amount"]').val());
    amount = isNaN(amount) ? 0 : amount;
    if (!amount) {
        showNotice('שגיאה', 'אנא בחר סכום', 'סגור');
        return false;
    }

    var error = false;
    var emailError = false;
    $('.required', $this).each(function () {
        var $this = $(this);
        if ($this.val() === '') {
            error = true;
        } else {
            if ($this.attr('name') === 'email') {
                if (!validateEmail($this.val())) {
                    emailError = true;
                }
            }
        }
    });

    if (error) {
        showNotice('שגיאה', 'אנא מלא את כל השדות הנדרשים', 'סגור');
        return false;
    }

    if (emailError) {
        showNotice('שגיאה', 'אנא הכנס כתובת אימייל תקינה', 'סגור');
        return false;
    }

    loading();

    // check if we are paypal
    var payload = {};

    if ($('.recaptcha-wrapper').length) {
        payload.recaptcha = $('.recaptcha-wrapper').attr('data-token');
    }

    if ($('.campaign-ils .add-donation [name="method"]:checked').val() === 'paypal') {
        payload['_token'] = $('meta[name="csrf-token"]').attr('content');
        payload.first_name = $('input[name="first_name"]', $this).val();
        payload.last_name = $('input[name="last_name"]', $this).val();
        payload.street = $('input[name="street"]', $this).val();
        // payload.city = $('input[name="city"]', $this).val();
        // payload.state = $('input[name="state"]', $this).val();
        // payload.zip = $('input[name="zip"]', $this).val();
        payload.email = $('input[name="email"]', $this).val();
        payload.phone = $('input[name="phone"]', $this).val();
        payload.amount = $('input[name="amount"]', $this).val();
        payload.source = $('input[name="source"]', $this).val();
        payload.method = $('input[name="method"]:checked', $this).val();

        $.ajax({
            type: 'POST',
            url: $this.attr('action'),
            data: payload,
            dataType: 'json',
            success: function (data) {
                console.log(data);

                if (!data.success) {
                    unloading();
                    showNotice('שגיאה', data.message, 'סגור');

                    if ($('.recaptcha-wrapper').length) {
                        grecaptcha.reset();
                        grecaptcha.execute();
                    }

                    return false;
                }

                if (data.location) {
                    window.location.href = data.location;
                    return false;
                }

                unloading();
                $this[0].reset();
                closeModal();
                showNotice('Success', data.message, 'סגור');
            },
            error: function (request) {
                console.log(request.responseText);
            }
        });

        return false;
    }

    payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    payload.first_name = $('input[name="first_name"]', $this).val();
    payload.last_name = $('input[name="last_name"]', $this).val();
    payload.street = $('input[name="street"]', $this).val();
    // payload.city = $('input[name="city"]', $this).val();
    // payload.state = $('input[name="state"]', $this).val();
    // payload.zip = $('input[name="zip"]', $this).val();
    payload.email = $('input[name="email"]', $this).val();
    payload.phone = $('input[name="phone"]', $this).val();
    payload.amount = $('input[name="amount"]', $this).val();
    payload.source = $('input[name="source"]', $this).val();
    payload.method = $('input[name="method"]:checked', $this).val();

    payload.card_number = $('input[name="card_number"]', $this).val();
    payload.cvv = $('input[name="cvv"]', $this).val();
    payload.month = $('input[name="month"]', $this).val();
    payload.year = $('input[name="year"]', $this).val();

    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            console.log(data);

            if (!data.success) {
                unloading();
                showNotice('שגיאה', data.message, 'סגור');

                if ($('.recaptcha-wrapper').length) {
                    grecaptcha.reset();
                    grecaptcha.execute();
                }
                return false;
            }

            if (data.location) {
                window.location.href = data.location;
                return false;
            }

            unloading();
            $this[0].reset();
            closeModal();
            showNotice('Success', data.message, 'סגור');
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });


    // setup the token
    // Stripe.setPublishableKey($('meta[name="stripe"]').attr('content'));
    // Stripe.card.createToken(
    //     {
    //         name: $('input[name="first_name"]', $this).val() + ' ' + $('input[name="last_name"]', $this).val(),
    //         number: $('input[name="card_number"]', $this).val(),
    //         cvc: $('input[name="cvv"]', $this).val(),
    //         exp_month: $('input[name="month"]', $this).val(),
    //         exp_year: $('input[name="year"]', $this).val(),
    //         address_line1: $('input[name="street"]', $this).val(),
    //         address_state: $('input[name="state"]', $this).val(),
    //         address_zip: $('input[name="zip"]', $this).val()
    //     },
    //     function(status, response) {
    //         // console.log(response);
    //         if (response.error) {
    //             unloading();
    //             showNotice('Error', response.error.message, 'close');
    //             return false;
    //         }

    //         payload['_token'] = $('meta[name="csrf-token"]').attr('content');
    //         payload.stripe_token = response.id;

    //         payload.first_name = $('input[name="first_name"]', $this).val();
    //         payload.last_name = $('input[name="last_name"]', $this).val();
    //         payload.street = $('input[name="street"]', $this).val();
    //         payload.city = $('input[name="city"]', $this).val();
    //         payload.state = $('input[name="state"]', $this).val();
    //         payload.zip = $('input[name="zip"]', $this).val();
    //         payload.email = $('input[name="email"]', $this).val();
    //         payload.phone = $('input[name="phone"]', $this).val();
    //         payload.brand = response.card.brand;
    //         payload.last_four = response.card.last4;
    //         payload.month = response.card.exp_month;
    //         payload.year = response.card.exp_year;
    //         payload.amount = $('input[name="amount"]', $this).val();
    //         payload.source = $('input[name="source"]', $this).val();
    //         payload.method = $('input[name="method"]:checked', $this).val();

    //         $.ajax({
    //             type: 'POST',
    //             url: $this.attr('action'),
    //             data: payload,
    //             dataType: 'json',
    //             success: function(data) {
    //                 console.log(data);
    //                 unloading();

    //                 if (!data.success) {
    //                     showNotice('Error', data.message, 'close');
    //                     return false;
    //                 }

    //                 $this[0].reset();
    //                 closeModal();
    //                 showNotice('Success', data.message, 'close');
    //             },
    //             error: function(request) {
    //                 console.log(request.responseText);
    //             }
    //         });

    //         return false;
    //     }
    // );

    return false;
});


// recent donations
$('body').on('click', '.campaign-ils .doners-wrapper .open-dropdown', function () {
    var $this = $(this);
    var menu = $this.parents('.dropdown-wrapper');

    menu.addClass('opened');
    closeDropdown($this.parents('.dropdown-wrapper').attr('data-dropdown'));
    return false;
});

$('body').on('click', '.campaign-ils .sort-donations-trigger', function () {
    var $this = $(this);
    closeDropdown();

    $.ajax({
        type: 'POST',
        url: 'donations',
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            _method: 'GET',
            page: $this.attr('data-page'),
            sort: $this.attr('data-sort')
        },
        dataType: 'json',
        success: function (data) {
            // console.log(data);

            // empty the current donations
            $('.donors ul').html('');

            // add new donations
            $.each(data.results.donations, function (index, donation) {
                $('.donors ul').append(`<li class="donor" data-donation="${donation.donation}">
                    <figure>
                        <img src="images/donor.svg" alt="donor">
                    </figure>
                    <div class="donor-info">
                        <p data-input="full_name">${donation.full_name}</p>
                        <time data-input="donation_date_human">${donation.donation_date_human}</time>
                    </div>

                    <div class="amount" data-input="amount_floored">
                        ${donation.amount_floored}
                    </div>
                </li>`);
            });

            // update the load more button
            $('.load-more-donors-wrapper').addClass('hidden');
            if (data.results.pagination['next-pages'].length) {
                $('.load-more-donors-wrapper').removeClass('hidden');

                // update the load more button
                $('.load-more-donors').attr('data-page', data.results.pagination['next-pages'][0]);
                $('.load-more-donors').attr('data-sort', data.results.sort);
            }


        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});

$('body').on('click', '.load-more-donors', function () {
    var $this = $(this);
    closeDropdown();

    $.ajax({
        type: 'POST',
        url: 'donations',
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            _method: 'GET',
            page: $this.attr('data-page'),
            sort: $this.attr('data-sort')
        },
        dataType: 'json',
        success: function (data) {
            // console.log(data);

            // add new donations
            $.each(data.results.donations, function (index, donation) {
                if ($('.donor[data-donation="' + donation.donation + '"]').length) {
                    return true;
                }

                $('.donors ul').append(`<li class="donor" data-donation="${donation.donation}">
                    <figure>
                        <img src="images/donor.svg" alt="donor">
                    </figure>
                    <div class="donor-info">
                        <p data-input="full_name">${donation.full_name}</p>
                        <time data-input="donation_date_human">${donation.donation_date_human}</time>
                    </div>    

                    <div class="amount" data-input="amount_floored">
                        ${donation.amount_floored}
                    </div>
                </li>`);
            });

            // update the load more button
            $('.load-more-donors-wrapper').addClass('hidden');
            if (data.results.pagination['next-pages'].length) {
                $('.load-more-donors-wrapper').removeClass('hidden');

                // update the load more button
                $('.load-more-donors').attr('data-page', data.results.pagination['next-pages'][0]);
                $('.load-more-donors').attr('data-sort', data.results.sort);
            }


        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
    return false;
});